import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal, Icon, Button, Form } from 'semantic-ui-react'

class MetaReplacer extends Component {
  constructor () {
    super(...arguments)

    this.state = {
      isOpen: false,
      searchProperty: '',
      replaceProperty: '',
      resultsLength: 0
    }

    this.handleReplaceButton = this.handleReplaceButton.bind(this)
    this.handleBlurFindInput = this.handleBlurFindInput.bind(this)
    this.handleChangeFormValue = this.handleChangeFormValue.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)

    window.addEventListener('keydown', this.handleKeyDown)
  }

  componentWillUnmount () {
    window.removeEventListener('keydown', this.handleKeyDown)
  }

  get replaceButton () {
    return (
      <Icon.Group
        title='Найти и заменить'
        onClick={() => { this.setState({ isOpen: true }) }}
      >
        <Icon name='find' />
        <Icon corner name='exchange' />
      </Icon.Group>
    )
  }

  handleReplaceButton () {
    const { meta, updateMeta } = this.props
    const { searchProperty, replaceProperty } = this.state

    this.newMeta = meta.slice(0)
    this._findAndReplace(this.newMeta, searchProperty, replaceProperty)
    const updatedMeta = this.newMeta.reduce((acc, cur, i) => {
      acc[cur.id] = cur
      return acc
    }, {})
    updateMeta({ meta: updatedMeta })
    this.setDefaultState()
  }

  handleBlurFindInput (e) {
    const { meta } = this.props

    this.equalCount = 0
    this._findEqualItemsCount(meta, e.target.value)
    this.setState({ resultsLength: this.equalCount })
  }

  handleChangeFormValue (key, value) {
    this.setState({ [key]: value })
  }

  handleKeyDown (e) {
    // close popup on Esc button
    if (e.keyCode === 27 && this.state.isOpen) {
      this.setDefaultState()
    }
  }

  setDefaultState () {
    this.setState({
      isOpen: false,
      searchProperty: '',
      replaceProperty: '',
      resultsLength: 0
    })
  }

  _findEqualItemsCount (data, property) {
    for (let item in data) {
      if (typeof data[item] === 'object') this._findEqualItemsCount(data[item], property)
      if (typeof data[item] !== 'object' && typeof item === 'string' && item === property) {
        this.equalCount++
      }
    }
  }

  _findAndReplace (data, property, replacer) {
    for (let item in data) {
      if (data.hasOwnProperty(item)) {
        if (typeof data[item] === 'object') {
          this._findAndReplace(data[item], property, replacer)
        }
        if (item === property) {
          data[property] = replacer
        }
      }
    }
  }

  render () {
    const { isOpen, searchProperty, replaceProperty, resultsLength } = this.state

    return (
      <div>
        {!isOpen && this.replaceButton}
        <Modal open={isOpen} dimmer>
          <Modal.Header>Поиск и замена событий</Modal.Header>
          <Modal.Content>
            <Form>
              <Form.Field>
                <label>Найти свойство</label>
                <Form.Input
                  onBlur={this.handleBlurFindInput}
                  onChange={(e) => { this.handleChangeFormValue('searchProperty', e.target.value) }}
                />
              </Form.Field>
              <Form.Field>
                <label>Найдено результатов: {resultsLength}</label>
              </Form.Field>
              <Form.Field disabled={!resultsLength}>
                <label>Заменить на</label>
                <Form.Input
                  readOnly={!resultsLength}
                  onChange={(e) => { this.handleChangeFormValue('replaceProperty', e.target.value) }}
                />
              </Form.Field>
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button
              color='orange'
              onClick={this.handleReplaceButton}
              disabled={!resultsLength || !searchProperty || !replaceProperty}
            >Заменить</Button>
            <Button onClick={() => { this.setDefaultState() }}>Закрыть</Button>
          </Modal.Actions>
        </Modal>
      </div>
    )
  }
}

const { array, func } = PropTypes

MetaReplacer.propTypes = {
  meta: array.isRequired,
  updateMeta: func.isRequired
}

export default MetaReplacer



// WEBPACK FOOTER //
// ./src/components/MetaReplacer/MetaReplacer.js